import { createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '@utils/api';
import { ErrorResponse } from 'store/ReduxTypes';
import {
  MentalHealthGetResponse,
  MentalHealthResult,
  MentalHealthResultsParams,
  MentalHealthResultSubmit,
  MentalHealthStatsParams,
  MentalHealthStatsResponse,
} from './MentalHealthTypes';

export const MENTAL_HEALTH_RESULTS_LIMIT = 100;
const MENTAL_HEALTH_RESULTS_OFFSET = 0;

const getMentalHealthResultsUrl = (
  limit = MENTAL_HEALTH_RESULTS_LIMIT,
  offset = MENTAL_HEALTH_RESULTS_OFFSET,
) => `/mental-health-test/results?limit=${limit}&offset=${offset}`;

const getMentalHealthStatsUrl = (limit = MENTAL_HEALTH_RESULTS_LIMIT) =>
  `/mental-health-test/stats?limit=${limit}`;

export const getMentalHealthTestOperation = createAsyncThunk<
  MentalHealthGetResponse,
  void,
  { rejectValue: ErrorResponse }
>('mentalHealth/getTest', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.get<MentalHealthGetResponse>('/mental-health-test');
    return data;
  } catch {
    return rejectWithValue({ message: 'Не удалось загрузить тест' });
  }
});

export const getMentalHealthResultsOperation = createAsyncThunk<
  MentalHealthResult[],
  MentalHealthResultsParams | void,
  { rejectValue: ErrorResponse }
>('mentalHealth/getResults', async (params, { rejectWithValue }) => {
  try {
    const { limit = MENTAL_HEALTH_RESULTS_LIMIT, offset = MENTAL_HEALTH_RESULTS_OFFSET } =
      params ?? {};
    const { data } = await api.get<MentalHealthResult[]>(getMentalHealthResultsUrl(limit, offset));
    return data;
  } catch {
    return rejectWithValue({ message: 'Не удалось загрузить историю' });
  }
});

export const getMentalHealthStatsOperation = createAsyncThunk<
  MentalHealthStatsResponse,
  MentalHealthStatsParams | void,
  { rejectValue: ErrorResponse }
>('mentalHealth/getStats', async (params, { rejectWithValue }) => {
  try {
    const { limit = MENTAL_HEALTH_RESULTS_LIMIT } = params ?? {};
    const { data } = await api.get<MentalHealthStatsResponse>(getMentalHealthStatsUrl(limit));
    return data;
  } catch {
    return rejectWithValue({ message: 'Не удалось загрузить статистику' });
  }
});

export const submitMentalHealthResultOperation = createAsyncThunk<
  MentalHealthResult,
  MentalHealthResultSubmit,
  { rejectValue: ErrorResponse }
>('mentalHealth/submitResult', async (payload, { rejectWithValue }) => {
  try {
    const { data } = await api.post<MentalHealthResult>('/mental-health-test/results', payload);
    return data;
  } catch {
    return rejectWithValue({ message: 'Не удалось сохранить результат' });
  }
});
